import React, { useState } from 'react';

const API = 'https://ster-ai-production.up.railway.app';

const STYLES = `
  @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700;800&display=swap');
  .onb-page { min-height: 100vh; background: #fff; display: flex; flex-direction: column; font-family: 'Inter', sans-serif; -webkit-font-smoothing: antialiased; }
  .onb-nav { padding: 28px 48px; display: flex; align-items: center; justify-content: space-between; }
  .onb-logo { display: flex; align-items: center; gap: 10px; font-size: 15px; font-weight: 700; color: #0f0f0f; }
  .onb-logo-dot { width: 9px; height: 9px; border-radius: 50%; background: #5E6AD2; }
  .onb-progress { display: flex; gap: 6px; }
  .onb-progress-dot { width: 24px; height: 3px; border-radius: 2px; background: #ececec; transition: background 0.25s ease; }
  .onb-progress-dot.done { background: #5E6AD2; }
  .onb-body { flex: 1; display: flex; align-items: center; justify-content: center; padding: 40px 24px; }
  .onb-card { width: 100%; max-width: 480px; opacity: 0; transform: translateY(8px); animation: onbIn 0.45s cubic-bezier(0.16,1,0.3,1) forwards; }
  @keyframes onbIn { to { opacity: 1; transform: translateY(0); } }
  .onb-eyebrow { font-size: 12px; font-weight: 600; color: #5E6AD2; letter-spacing: 0.4px; margin-bottom: 14px; }
  .onb-title { font-size: 30px; font-weight: 800; letter-spacing: -0.9px; color: #0f0f0f; line-height: 1.15; margin-bottom: 14px; }
  .onb-sub { font-size: 15px; color: #6b6b6b; line-height: 1.55; margin-bottom: 36px; }
  .onb-field-label { font-size: 13px; font-weight: 600; color: #0f0f0f; margin-bottom: 8px; display: block; }
  .onb-textarea, .onb-input { width: 100%; padding: 14px 52px 14px 16px; border: 1.5px solid #ececec; border-radius: 12px; font-size: 15px; font-family: 'Inter', sans-serif; outline: none; resize: none; transition: all 0.15s ease; background: #fafafa; color: #0f0f0f; }
  .onb-textarea:focus, .onb-input:focus { border-color: #5E6AD2; background: #fff; box-shadow: 0 0 0 4px rgba(94,106,210,0.1); }
  .onb-textarea { min-height: 110px; line-height: 1.5; }
  .onb-hint { font-size: 12.5px; color: #a3a3a3; margin-top: 8px; }
  .onb-actions { display: flex; align-items: center; gap: 14px; margin-top: 32px; }
  .onb-btn-primary { padding: 13px 26px; border-radius: 12px; border: none; background: #0f0f0f; color: #fff; font-size: 14.5px; font-weight: 600; font-family: 'Inter', sans-serif; cursor: pointer; transition: all 0.18s ease; display: inline-flex; align-items: center; gap: 8px; }
  .onb-btn-primary:hover:not(:disabled) { background: #5E6AD2; transform: translateY(-1px); box-shadow: 0 8px 20px rgba(94,106,210,0.28); }
  .onb-btn-primary:disabled { opacity: 0.35; cursor: not-allowed; }
  .onb-btn-ghost { padding: 13px 18px; border-radius: 12px; border: none; background: none; color: #9a9a9a; font-size: 14px; font-weight: 500; font-family: 'Inter', sans-serif; cursor: pointer; }
  .onb-btn-ghost:hover { color: #0f0f0f; }
  .onb-loader { width: 40px; height: 40px; border-radius: 50%; border: 3px solid #ececec; border-top-color: #5E6AD2; animation: onbSpin 0.8s linear infinite; margin: 0 auto 28px; }
  @keyframes onbSpin { to { transform: rotate(360deg); } }
  .onb-loading-title { text-align: center; font-size: 17px; font-weight: 600; color: #0f0f0f; }
  .onb-loading-sub { text-align: center; font-size: 13.5px; color: #9a9a9a; margin-top: 8px; }
  .onb-recap-box { background: #fafafa; border: 1px solid #ececec; border-radius: 16px; padding: 22px 24px; margin-bottom: 28px; }
  .onb-recap-row { display: flex; align-items: center; gap: 10px; padding: 9px 0; font-size: 14px; color: #0f0f0f; }
  .onb-recap-row:not(:last-child) { border-bottom: 1px solid #f0f0f0; }
  .onb-recap-dot { width: 8px; height: 8px; border-radius: 50%; flex-shrink: 0; }
  .onb-field-wrap { position: relative; }
  .mic-btn { position: absolute; right: 10px; bottom: 10px; width: 32px; height: 32px; border-radius: 50%; border: none; background: #f0eeeb; color: #6b6b6b; cursor: pointer; display: flex; align-items: center; justify-content: center; transition: all 0.18s ease; }
  .onb-input ~ .mic-btn { bottom: 50%; transform: translateY(50%); }
  .mic-btn:hover { background: #ececec; color: #0f0f0f; }
  .mic-btn.listening { background: #5E6AD2; color: #fff; }
  .mic-pulse { position: absolute; inset: -4px; border-radius: 50%; border: 2px solid #5E6AD2; animation: micPulse 1.4s ease-out infinite; }
  @keyframes micPulse { 0% { transform: scale(0.9); opacity: 0.8; } 100% { transform: scale(1.5); opacity: 0; } }
`;

const CATEGORY_COLORS = { rouge: '#EF4444', jaune: '#F59E0B', vert: '#22C55E', gris: '#9CA3AF' };

const IconMicSmall = () => <svg width="15" height="15" viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.4"><rect x="5.5" y="1.5" width="5" height="8" rx="2.5"/><path d="M3 7.5a5 5 0 0 0 10 0" strokeLinecap="round"/><path d="M8 12.5V14.5M5.5 14.5h5" strokeLinecap="round"/></svg>;

const MIC_ERREURS = {
  'not-allowed': "Micro refusé — autorisez l'accès au micro dans les réglages du navigateur pour ce site.",
  'service-not-allowed': "Micro refusé — autorisez l'accès au micro dans les réglages du navigateur pour ce site.",
  'no-speech': "Rien entendu, réessayez.",
  'audio-capture': "Aucun micro détecté sur cet appareil.",
  'network': "Problème de connexion pendant la dictée, réessayez.",
};

function MicButton({ onTranscript }) {
  const recognitionRef = React.useRef(null);
  const [listening, setListening] = useState(false);
  const [erreur, setErreur] = useState(null);
  const supported = typeof window !== 'undefined' && (window.SpeechRecognition || window.webkitSpeechRecognition);
  const secure = typeof window !== 'undefined' && (window.location.protocol === 'https:' || window.location.hostname === 'localhost');

  const toggle = () => {
    setErreur(null);
    if (!supported) { setErreur("La dictée vocale n'est pas supportée par ce navigateur (utilisez Chrome ou Edge)."); return; }
    if (!secure) { setErreur("La dictée vocale nécessite une connexion sécurisée (https)."); return; }
    if (listening) { recognitionRef.current && recognitionRef.current.stop(); setListening(false); return; }
    const SR = window.SpeechRecognition || window.webkitSpeechRecognition;
    const rec = new SR();
    rec.lang = 'fr-FR';
    rec.continuous = true;
    rec.interimResults = false;
    rec.onresult = (e) => {
      let texte = '';
      for (let i = e.resultIndex; i < e.results.length; i++) {
        if (e.results[i].isFinal) texte += e.results[i][0].transcript;
      }
      if (texte.trim()) onTranscript(texte.trim());
    };
    rec.onend = () => setListening(false);
    rec.onerror = (e) => { setListening(false); setErreur(MIC_ERREURS[e.error] || `Erreur du micro (${e.error}), réessayez.`); };
    recognitionRef.current = rec;
    try {
      rec.start();
      setListening(true);
    } catch {
      setErreur("Impossible de démarrer le micro, réessayez.");
    }
  };

  return (
    <>
      <button type="button" className={`mic-btn ${listening ? 'listening' : ''}`} onClick={toggle} title="Dicter avec la voix">
        <IconMicSmall />
        {listening && <span className="mic-pulse" />}
      </button>
      {erreur && <div style={{ position: 'absolute', right: 0, bottom: -26, fontSize: 12, color: '#dc2626', whiteSpace: 'nowrap' }}>{erreur}</div>}
    </>
  );
}

function Onboarding({ token, onComplete }) {
  const [step, setStep] = useState(0);
  const [besoin, setBesoin] = useState('');
  const [categories, setCategories] = useState('');
  const [loading, setLoading] = useState(false);
  const [erreur, setErreur] = useState('');
  const [resultat, setResultat] = useState(null);

  const totalSteps = 4;

  const valider = async () => {
    setLoading(true);
    setErreur('');
    try {
      const res = await fetch(`${API}/onboarding/completer`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
        body: JSON.stringify({ besoin, categories: categories || 'Prioritaire, À vérifier, RAS' }),
      });
      if (!res.ok) { setErreur("Une erreur est survenue, réessayez."); setLoading(false); return; }
      const data = await res.json();
      setResultat(data);
      setStep(3);
    } catch {
      setErreur("Impossible de contacter le serveur.");
    }
    setLoading(false);
  };

  return (
    <div className="onb-page">
      <style>{STYLES}</style>
      <div className="onb-nav">
        <div className="onb-logo"><span className="onb-logo-dot" /> Ster-AI</div>
        <div className="onb-progress">
          {Array.from({ length: totalSteps }).map((_, i) => (
            <div key={i} className={`onb-progress-dot ${i <= step ? 'done' : ''}`} />
          ))}
        </div>
      </div>

      <div className="onb-body">
        {step === 0 && (
          <div className="onb-card" key="0">
            <div className="onb-eyebrow">BIENVENUE</div>
            <div className="onb-title">Configurons votre espace.</div>
            <div className="onb-sub">Deux questions rapides suffisent pour que Ster-AI comprenne exactement ce que vous voulez automatiser — et s'adapte à votre façon de travailler, pas l'inverse.</div>
            <div className="onb-actions">
              <button className="onb-btn-primary" onClick={() => setStep(1)}>Commencer →</button>
            </div>
          </div>
        )}

        {step === 1 && (
          <div className="onb-card" key="1">
            <div className="onb-eyebrow">1 SUR 2</div>
            <div className="onb-title">Qu'est-ce qu'on automatise ?</div>
            <div className="onb-sub">Décrivez le document que vous allez nous envoyer, et ce que vous voulez qu'on en fasse.</div>
            <label className="onb-field-label">Votre besoin</label>
            <div className="onb-field-wrap">
              <textarea
                className="onb-textarea"
                placeholder="Ex : Je reçois des rapports d'audit de mes équipes, je veux repérer ceux qui signalent un risque important"
                value={besoin}
                onChange={e => setBesoin(e.target.value)}
                autoFocus
              />
              <MicButton onTranscript={t => setBesoin(prev => (prev ? prev.trim() + ' ' : '') + t)} />
            </div>
            <div className="onb-actions">
              <button className="onb-btn-primary" onClick={() => setStep(2)} disabled={besoin.trim().length < 8}>Continuer →</button>
              <button className="onb-btn-ghost" onClick={() => setStep(0)}>Retour</button>
            </div>
          </div>
        )}

        {step === 2 && !loading && (
          <div className="onb-card" key="2">
            <div className="onb-eyebrow">2 SUR 2</div>
            <div className="onb-title">Comment classer chaque document ?</div>
            <div className="onb-sub">Donnez-nous vos propres catégories — Ster-AI les utilisera partout dans votre espace, avec vos mots.</div>
            <label className="onb-field-label">Vos catégories</label>
            <div className="onb-field-wrap">
              <input
                className="onb-input"
                placeholder="Ex : Urgent, À surveiller, RAS"
                value={categories}
                onChange={e => setCategories(e.target.value)}
                autoFocus
              />
              <MicButton onTranscript={t => setCategories(prev => (prev ? prev.trim() + ' ' : '') + t)} />
            </div>
            <div className="onb-hint">Pas d'idée précise ? Laissez vide, on vous propose quelque chose de sensé.</div>
            {erreur && <div className="onb-hint" style={{ color: '#dc2626' }}>{erreur}</div>}
            <div className="onb-actions">
              <button className="onb-btn-primary" onClick={valider} disabled={loading}>
                {loading ? 'Configuration en cours...' : 'Configurer mon espace →'}
              </button>
              <button className="onb-btn-ghost" onClick={() => setStep(1)} disabled={loading}>Retour</button>
            </div>
          </div>
        )}

        {step === 3 && resultat && (
          <div className="onb-card" key="3">
            <div className="onb-eyebrow">C'EST PRÊT</div>
            <div className="onb-title">Votre espace est configuré.</div>
            <div className="onb-sub">Voici comment Ster-AI classera vos documents à partir de maintenant :</div>
            <div className="onb-recap-box">
              {Object.entries(resultat.labels || {}).map(([cle, val]) => (
                <div className="onb-recap-row" key={cle}>
                  <span className="onb-recap-dot" style={{ background: CATEGORY_COLORS[cle] || '#9CA3AF' }} />
                  {val}
                </div>
              ))}
            </div>
            <div className="onb-sub" style={{ marginBottom: 0 }}>Il ne reste qu'à déposer votre premier document pour voir ça en action.</div>
            <div className="onb-actions">
              <button className="onb-btn-primary" onClick={() => onComplete(besoin)}>Accéder à mon espace →</button>
            </div>
          </div>
        )}

        {loading && step === 2 && (
          <div className="onb-card" key="loading">
            <div className="onb-loader" />
            <div className="onb-loading-title">L'IA configure votre espace...</div>
            <div className="onb-loading-sub">Quelques secondes</div>
          </div>
        )}
      </div>
    </div>
  );
}

export default Onboarding;
export { MicButton };
